import React from 'react';
import { XIcon } from 'lucide-react';
import { pains } from '../data/pains';
import { Reveal } from './ui/Reveal';
export function PainSection() {
  return <section aria-labelledby="pain-title" className="border-b border-line bg-surface/40" data-id="element-181" data-mp="38vu7s8uzq744">
      <div className="mx-auto grid max-w-content gap-12 px-5 py-16 sm:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:py-24" style={{
      paddingTop: "23px",
      paddingBottom: "19px",
      gap: "19px"
    }} data-id="element-182" data-mp="2uxvxbejsiutw">
        <div data-id="element-183" data-mp="2l715lunrz312">
          <h2 id="pain-title" className="text-center text-2xl font-black leading-tight tracking-tight text-ivory sm:text-3xl lg:text-4xl" style={{
          fontSize: "13px"
        }} data-id="element-184" data-mp="2l6j1ycys9mj4">
            ¿Cuántos conflictos más vas a vivir así?
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-center text-base leading-relaxed text-muted sm:text-lg" style={{
          fontSize: "10px"
        }} data-id="element-185" data-mp="2ga12nsm82ge6">
            Sos padre o madre, amás a tu hijo, pero nadie te dijo que ibas a pasar los conflictos siendo fiscal, improvisando límites y llegando al lunes emocionalmente agotado.
          </p>
          <p className="mx-auto mt-6 max-w-md rounded-xl border border-line bg-surface px-5 py-4 text-center text-lg font-bold text-ivory sm:text-xl" style={{
          fontSize: "12px",
          color: "#F6A93B"
        }} data-id="element-186" data-mp="3rovd0tnrkc8m">
            No es falta de amor. 
Es falta de un sistema.
          </p>
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/3209979a-4c4b-4299-8597-985289019146.jpg" alt="Una madre y su hijo adolescente conversando con calma en la cocina" className="mt-10 hidden w-full rounded-2xl border border-line object-cover lg:block" loading="lazy" data-id="element-187" data-mp="ewskr70w5ga" />
        </div>

        <div data-id="element-188" data-mp="3dvmc7hdvsz1p">
          <ul className="grid gap-3 sm:grid-cols-2" data-id="element-189" data-mp="3dv45fqtlf2fj">
            {pains.map((pain, i) => <Reveal key={pain} delay={i * 0.03} className="h-full" data-id="element-190" data-mp="2q61q4pmfllo7" data-mpi={i}>
                <li className="flex h-full items-start gap-3 rounded-xl border border-line bg-surface p-4" data-id="element-191" data-mp="2q474f93c5pj2">
                  <XIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-danger" data-id="element-192" data-mp="2l4uiqro7aoi2" />
                  <span className="text-[15px] leading-relaxed text-ivory" style={{
                fontSize: "12px"
              }} data-id="element-193" data-mp="p3k3o1yaqs0i">{pain}</span>
                </li>
              </Reveal>)}
          </ul>
          <p className="mx-auto mt-8 max-w-lg text-center text-xl font-black leading-snug tracking-tight text-accent sm:text-2xl" style={{
          fontSize: "13px"
        }} data-id="element-194" data-mp="yvq502afulsd">
            ¿Y si este fuera el último conflicto que volvés a improvisar?
          </p>
        </div>
      </div>
    </section>;
}